import React from 'react'
import './Categories.scss'

function Categories() {
  return (
    <div>Categories</div>
  )
}

export default Categories